(() => {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initVideoHeroes = (root = document) => {
    root.querySelectorAll('[data-su-video-hero]:not([data-su-ready])').forEach((hero) => {
      hero.dataset.suReady = 'true';
      const video = hero.querySelector('[data-su-autoplay], video');
      const toggle = hero.querySelector('[data-su-video-toggle]');
      if (!video) return;

      const play = () => video.play().then(() => {
        toggle?.classList.remove('is-paused');
        toggle?.setAttribute('aria-label', 'Pause background video');
      }).catch(() => {
        toggle?.classList.add('is-paused');
        toggle?.setAttribute('aria-label', 'Play background video');
      });

      if (!prefersReducedMotion()) play();
      else toggle?.classList.add('is-paused');

      toggle?.addEventListener('click', () => {
        if (video.paused) play();
        else {
          video.pause();
          toggle.classList.add('is-paused');
          toggle.setAttribute('aria-label', 'Play background video');
        }
      });
    });
  };

  const initTabs = (root = document) => {
    root.querySelectorAll('[data-su-tabs]:not([data-su-ready])').forEach((tabs) => {
      tabs.dataset.suReady = 'true';
      const buttons = [...tabs.querySelectorAll('[data-su-tab]')];
      const panels = [...tabs.querySelectorAll('[data-su-panel]')];
      const activate = (index, focus = false) => {
        buttons.forEach((button, i) => {
          const active = i === index;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
        });
        if (focus) buttons[index]?.focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          activate(next, true);
        });
      });
      activate(0);
    });
  };

  const initSliders = (root = document) => {
    root.querySelectorAll('[data-su-slider]:not([data-su-ready])').forEach((slider) => {
      slider.dataset.suReady = 'true';
      const track = slider.querySelector('[data-su-slider-track]');
      if (!track) return;
      const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * .88, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      slider.querySelector('[data-su-slider-prev]')?.addEventListener('click', () => move(-1));
      slider.querySelector('[data-su-slider-next]')?.addEventListener('click', () => move(1));
    });
  };

  const initReveal = (root = document) => {
    const targets = root.querySelectorAll('.su-premium-heading, .su-editorial__grid, .su-benefits__grid, .su-social-gallery__grid, .su-ugc__grid, .su-faq__grid');
    targets.forEach((target) => target.setAttribute('data-su-reveal', ''));
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), { threshold: .12 });
    targets.forEach((target) => observer.observe(target));
  };

  const initStickyCart = (root = document) => {
    root.querySelectorAll('[data-su-sticky-cart]:not([data-su-ready])').forEach((sticky) => {
      sticky.dataset.suReady = 'true';
      const mainButton = document.querySelector('main product-form button[name="add"]');
      const variantInput = sticky.querySelector('[data-su-sticky-variant]');
      const price = sticky.querySelector('[data-su-sticky-price]');
      const button = sticky.querySelector('.su-sticky-cart__button');
      const label = sticky.querySelector('[data-su-sticky-label]');

      if (mainButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .15 });
        observer.observe(mainButton);
      } else sticky.classList.add('is-visible');

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const variant = data?.variant;
          if (!variant || !variantInput) return;
          variantInput.value = variant.id;
          variantInput.disabled = !variant.available;
          button?.setAttribute('aria-disabled', String(!variant.available));
          if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
          if (price) {
            const currency = window.Shopify?.currency?.active || 'GBP';
            price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(variant.price / 100);
          }
        });
      }
    });
  };

  const initPremium = (root = document) => {
    initVideoHeroes(root);
    initTabs(root);
    initSliders(root);
    initReveal(root);
    initStickyCart(root);
  };

  document.addEventListener('DOMContentLoaded', () => initPremium());
  document.addEventListener('shopify:section:load', (event) => initPremium(event.target));
})();
